export const HEXACO_SAMPLE_REPORT_URLS = {
  en: "https://appconfig.deepsoulai.com/hexaco_sample/hexaco_detail_report_en.pdf",
  zh: "https://appconfig.deepsoulai.com/hexaco_sample/hexaco_detail_report_zh_hk.pdf",
};

const HEXACO_EXPLORE_IMAGE_BASE =
  "https://assets.deepsoulai.com/hexaco/explore";

export const HEXACO_EXPLORE_IMAGE_URLS: string[] = [
  `${HEXACO_EXPLORE_IMAGE_BASE}/1.jpeg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/2.jpg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/3.jpg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/4.jpg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/5.jpg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/6.jpeg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/7.jpeg`,
  `${HEXACO_EXPLORE_IMAGE_BASE}/8.jpg`,
];
